module.exports = __webpack_public_path__ + "img/cw-logos-design.0816338a.png";